(function () {
  var fmt = function (paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toast = $('#toast');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 1800);
  }

  /* ---------- Header toggles ---------- */
  var searchBar = $('#searchBar');
  var searchToggle = $('#searchToggle');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('open');
      if (searchBar.classList.contains('open')) $('input', searchBar).focus();
    });
  }
  var mobileMenu = $('#mobileMenu');
  var menuToggle = $('#menuToggle');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () { mobileMenu.classList.toggle('open'); });
  }

  /* ---------- Cart drawer ---------- */
  var overlay = $('#overlay');
  var drawer = $('#cartDrawer');
  var bagCount = $('#bagCount');
  var drawerItems = $('#drawerItems');
  var subtotalEl = $('#subtotal');

  function openDrawer() { if (drawer) { drawer.classList.add('active'); overlay.classList.add('active'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('active'); overlay.classList.remove('active'); } }

  var cartToggle = $('#cartToggle');
  if (cartToggle) cartToggle.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  var drawerClose = $('#drawerClose');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function renderCart(cart) {
    if (bagCount) bagCount.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = fmt(cart.items_subtotal_price);
    if (!drawerItems) return;
    if (cart.item_count === 0) {
      drawerItems.innerHTML =
        '<div class="drawer-empty">' +
        '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg>' +
        '<p>Your bag is empty.</p><p style="font-size:12px;">Go find something good.</p></div>';
      return;
    }
    drawerItems.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x120$1$2') + '" alt="" loading="lazy">'
        : '';
      return '<div class="drawer-item">' +
        '<div class="di-visual">' + img + '</div>' +
        '<div class="di-info">' +
        '<h4><a href="' + item.url + '">' + item.product_title + '</a></h4>' +
        '<div class="di-price">' + fmt(item.final_price) + ' × ' + item.quantity + '</div>' +
        '<div class="di-qty">' +
        '<button data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
        '<button class="di-remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
        '</div></div></div>';
    }).join('');
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawerItems) {
    drawerItems.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-action]');
      if (!btn) return;
      var key = btn.dataset.key;
      var qty = Number(btn.dataset.qty || 0);
      if (btn.dataset.action === 'inc') changeQty(key, qty + 1);
      if (btn.dataset.action === 'dec') changeQty(key, qty - 1);
      if (btn.dataset.action === 'remove') changeQty(key, 0);
    });
  }

  window.MDAddToCart = function (variantId, qty, title) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to bag'); });
      return r.json();
    }).then(function () {
      return refreshCart().then(function () {
        showToast((title || 'Item') + ' added to bag');
        openDrawer();
      });
    }).catch(function (err) { showToast(err.message); });
  };

  /* Quick add buttons on product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.MDAddToCart(btn.dataset.variantId, 1, btn.dataset.title);
  });

  /* ---------- Homepage category filters ---------- */
  var filtersBar = $('#filters');
  var grid = $('#productGrid');
  if (filtersBar && grid) {
    filtersBar.addEventListener('click', function (e) {
      var btn = e.target.closest('.pill');
      if (!btn) return;
      $$('.pill', filtersBar).forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var f = btn.dataset.filter;
      var visible = 0;
      $$('.card', grid).forEach(function (card) {
        var cats = (card.dataset.collections || '').split(',');
        var show = f === 'all' || cats.indexOf(f) !== -1;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      var empty = $('.empty-grid', grid);
      if (empty) empty.style.display = visible === 0 ? '' : 'none';
    });
  }

  /* ---------- PDP ---------- */
  var pdpForm = $('#pdpForm');
  if (pdpForm) {
    var variantSelect = $('#variantSelect');
    var qtyInput = $('#pdpQty');
    $$('.qty-box button', pdpForm).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = Number(qtyInput.value) + (b.dataset.dir === 'up' ? 1 : -1);
        qtyInput.value = Math.max(1, v);
      });
    });
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var priceEl = $('#pdpPrice');
        if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.priceHtml || opt.dataset.price;
        var btn = $('#pdpAddBtn');
        if (btn) {
          var avail = opt.dataset.available === 'true';
          btn.disabled = !avail;
          btn.textContent = avail ? btn.dataset.labelAdd : 'Sold out';
        }
      });
    }
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = variantSelect ? variantSelect.value : pdpForm.dataset.variantId;
      window.MDAddToCart(id, Number(qtyInput.value) || 1, pdpForm.dataset.title);
    });
    var buyBtn = $('#pdpBuyBtn');
    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = variantSelect ? variantSelect.value : pdpForm.dataset.variantId;
        buyBtn.disabled = true;
        buyBtn.textContent = 'Taking you to checkout…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: Number(qtyInput.value) || 1 })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not buy now'); });
          window.location.href = '/checkout';
        }).catch(function (err) {
          buyBtn.disabled = false;
          buyBtn.textContent = 'Buy Now';
          showToast(err.message);
        });
      });
    }
    $$('.pdp-thumbs button').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.pdp-thumbs button').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        var main = $('#pdpMainImg');
        if (main) main.src = t.dataset.full;
      });
    });
  }

  /* ---------- Collection sort ---------- */
  var sortSelect = $('#sortSelect');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  refreshCart();
})();
